import React, { useEffect, useMemo, useState } from 'react';
import apiService from 'services/apiService';

const fetchConversationData = async (pageData) => {
  try {
    const searchParams = new URLSearchParams({
      sort: 'date_desc',
      _index: 'laki_puheenvuoro',
      term: pageData.searchWords.join(' OR '),
      size: '50'
    });
    const results = await apiService.fetchData(
      `search/all?${searchParams.toString()}`,
    );
    return results.hits.hits;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const removeH4FromHighlight = (highlights) => {
  // the spearker is in <h4> tags. Remove the tag, keep the name.
  return highlights.map((highlight) => {
    const h4ContentEndIndex = highlight.indexOf('</h4>');
    const h4ContentStartIndex = highlight.indexOf('>') + 1;

    // <h4>Saku Nikkanen (sd)</h4>
    const titleHTML = highlight.slice(
      0,
      h4ContentEndIndex + 5, // include tag
    );
    const speakerName = titleHTML.slice(
      h4ContentStartIndex,
      h4ContentEndIndex,
    );

    const withoutTitle = highlight.replace(titleHTML, '');
    return speakerName + ': ' + withoutTitle;
  });
};

const ParliamentConversationsBox = ({
  pageData,
  setIsLoading,
}) => {
  const [boxData, setBoxData] = useState([]);

  useEffect(() => {
    // async returns a Promise, so use then
    fetchConversationData(pageData)
      .then(setBoxData)
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setIsLoading(false));

    // cleanup on unmount
    return () => {
      setBoxData([]);
    };
  }, [pageData]);

  const conversationData = useMemo(() => {
    return boxData
      .map((entry) => {
        const { _id: id, _source: source } = entry;
        const rawHighlights =
          entry?.highlight?.puheenvuorot;

        if (
          source === 'undefined' ||
          rawHighlights === undefined ||
          rawHighlights.length === 0
        ) {
          return null;
        }

        const filteredHighlights = rawHighlights.filter(
          (highlight) =>
            !highlight.includes('Hakusana mainittu myös'),
        );

        const highlights = removeH4FromHighlight(
          filteredHighlights,
        );

        // title = "Keskiviikkona xx.xx.xxxx klo. ..." -> take date
        const date = source.title.split(' ')[1];
        return {
          id,
          date,
          highlights,
        };
      })
      .filter((entry) => entry !== null);
  }, [boxData]);

  return conversationData.map((conversation, i) => (
    <div
      className="smaller-font"
      key={conversation.date + '_' + i}
    >
      <a
        href={`/asiakirjat/poytakirja/${conversation.id}`}
        style={{ fontWeight: 600, color: "black" }}
      >
        Eduskunnan täysistunto {conversation.date}
      </a>
      <div className="smaller-font">
        {conversation.highlights.map((highlight, i) => (
          <p
            className="conversation-entry"
            key={i}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: highlight,
            }}
          ></p>
        ))}
      </div>
    </div>
  ));
};

export default ParliamentConversationsBox;
